<template>
    <div class="index-1-left-1" @click="clickIndex()">
        <div>
            <div class="index-title" style="display: flex;">
                <img src="/img/home/fangxing.png" alt="" style="width: 20px;height: 20px;margin-right: 5px;">
                <span>房型空闲占比</span>
            </div>
        </div>
        <div id="roomStyle" style="height:239px"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import {getPropertyAssetsIndex} from '@/api/index/propertyIndexApi'

export default {
    name: 'IndexCommunity',
    data() {
        return {
            indexOwnerRoomInfo: {},
            ownerRoomChart: null
        }
    },
    created() {
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
        if (this.ownerRoomChart) {
            this.ownerRoomChart.dispose()
        }
    },
    methods: {
        handleResize() {
            if (this.ownerRoomChart) {
                this.ownerRoomChart.resize()
            }
        },
        clickIndex() {
            this.$router.push('/pages/property/roomStructure')
        },
        async _loadPropertyIndexAssets() {
            const param = {
                page: 1,
                row: 10,
                communityId: this.getCommunityId()
            }

            try {
                const res = await getPropertyAssetsIndex(param)
                Object.assign(this.indexOwnerRoomInfo, res.data)
                this.$nextTick(() => {
                    const dom = document.getElementById('roomStyle')
                    if (!dom) return

                    if (this.ownerRoomChart) {
                        this.ownerRoomChart.dispose()
                    }
                    this.ownerRoomChart = echarts.init(dom)
                    this._initOwnerEcharts(
                        this.ownerRoomChart, this.indexOwnerRoomInfo.revenueData.roomSumList, this.indexOwnerRoomInfo.revenueData.roomKongxianList
                    )
                })
            } catch (error) {
                console.error('请求失败处理', error)
            }
        },
        _initOwnerEcharts(chart, ttt, fff) {
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {show: false}
                    },
                    formatter: function (params) {
                        const total = ttt[params[0].dataIndex];
                        const free = fff[params[0].dataIndex];
                        const used = total - free;
                        return `空闲: ${free}<br>使用中: ${used}<br>总计: ${total}`;
                    }
                },
                legend: {
                    data: ['空闲', '使用中'],
                    top: 'top',
                    // left: 'left',
                },
                xAxis: {
                    type: 'category',
                    data: this.indexOwnerRoomInfo.revenueData.roomList
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    minInterval: 30,
                },
                series: [
                    {
                        name: '使用中',
                        type: 'bar',
                        stack: 'total',
                        data: ttt.map((sum, index) => sum - fff[index]),
                        itemStyle: {color: '#4D6AFF'}
                    },
                    {
                        name: '空闲',
                        type: 'bar',
                        stack: 'total',
                        data: fff,
                        itemStyle: {color: '#C0C4DE'}
                    },
                ]
            };
            chart.setOption(option)
        }
    }
}
</script>

<style lang="scss" scoped>

.index-1-left-1 {
    border: 1px solid rgba(179, 186, 222, 1);
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 15px 0 15px;

    .index-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
        text-align: left;
        color: #333;
    }

}
</style>
